import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()(
  (
    theme,
    { printType, isKiteUser, nativeColor, colorType, strokeWidth } = {},
  ) => {
    let color;

    if (colorType) {
      color = theme.palette[colorType];
    }
    if (!nativeColor && !colorType) {
      color = isKiteUser ? theme.palette.primary1 : theme.palette.primary2;
    }

    return {
      icon: {
        cursor: 'pointer',
        [printType]: color,
        '& path': {
          [printType]: color,
          strokeWidth,
        },
      },
    };
  },
);
